// Localização: ./src/components/Layout/PageTitle.jsx
// Componente de título padrão elegante para todas as páginas

import React from 'react';

/**
 * Componente de título padrão com gradiente verde e subtítulo
 * @param {string} title - Título principal da página
 * @param {string} subtitle - Subtítulo descritivo (opcional)
 * @param {React.ReactNode} children - Conteúdo adicional (ex: botões) que aparece ao lado do título
 */
const PageTitle = ({ title, subtitle, children }) => {
    return (
        <div className="mb-6">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
                <div className="flex-1">
                    <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center">
                        <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                            {title}
                        </span>
                    </h1>
                    {subtitle && (
                        <p className="text-sm text-gray-500 font-medium">
                            {subtitle}
                        </p>
                    )}
                </div>
                {children && (
                    <div className="flex-shrink-0">
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PageTitle;
